import script from "/app/pages/Home/pdf_viewer.vue?type=script";
import "/app/pages/Home/pdf_viewer.vue?type=style";
import { render } from "/app/pages/Home/pdf_viewer.vue?type=template";
script.render = render;
export default script;
